import { useContext, useEffect, useState } from 'react';
import { Row } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { CODE, ORDER_TYPE_ID, RESPONSE_MESSAGE } from '../../../utils/Constant';
import '../../PhanHeKhamBenh.scss';
import { PhanHeTiepDonContext } from '../../contexts/PhanHeTiepDonContext';
import TableDonThuoc from './components/table-don-thuoc';
import ThaoTacDonThuoc from './components/thao-tac-don-thuoc';
import ThongTinPhieu from './components/thong-tin-phieu';

import { TabThuocContextProvider } from './context';
import { getMedicalItemsByType } from '../../services/ThuocService';

export type KhamBenh = {
	thongTinKhamBenh?: any;
	setThongTinKhamBenh: ((data: any) => void) | undefined;
};

type Props = {
	danhSachPhieu?: boolean;
	generalInfo?: any;
};

export const TabThuoc = ({ generalInfo = {} }: Props) => {
	const { benhNhanInfo } = useContext(PhanHeTiepDonContext);
	const { orderId, visit } = benhNhanInfo?.thongTinKhamBenh ?? generalInfo;

	const [danhSachDonThuoc, setDanhSachDonThuoc] = useState<object[]>([]);

	useEffect(() => {
		if (orderId) {
			getDanhSachDonThuoc();
		}
	}, [orderId, benhNhanInfo?.updateTab, generalInfo?.updateTab]);

	const getDanhSachDonThuoc = async () => {
		try {
			const { code, data } = await getMedicalItemsByType({
				visitId: visit?.id,
				type: ORDER_TYPE_ID.THUOC,
			});

			if (CODE.SUCCESS === code) {
				setDanhSachDonThuoc(data);
			}
		} catch (error) {
			console.error(error);
			toast.error(RESPONSE_MESSAGE.ERROR);
		}
	};

	return (
		<Row className="h-100">
			<div>
				<TabThuocContextProvider
					values={{
						danhSachDonThuoc,
						setDanhSachDonThuoc
					}}
				>
					<ThongTinPhieu />
					<TableDonThuoc generalInfo={generalInfo} />
					<ThaoTacDonThuoc generalInfo={generalInfo} getDanhSachDonThuoc={getDanhSachDonThuoc} />
				</TabThuocContextProvider>
			</div>
		</Row>
	);
};

export default TabThuoc;
